import { LAYOUT_TOGGLE_ACTION, LAYOUT_RENAME_ACTION } from '../actions/layout';

const initState = {
  title: 'Back office',
  open: false
};
export default function(state = initState, action) {
  let { type } = action;

  switch (type) {
    case LAYOUT_TOGGLE_ACTION:
      return Object.assign({}, state, {
        open: !state.open
      });

    case LAYOUT_RENAME_ACTION:
      return Object.assign({}, state, {
        title: action.title || initState.title
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/layout.js